import { motion } from "framer-motion";

const stats = [
  { value: "SOAP", label: "AI notes ready before checkout" },
  { value: "PMS", label: "Scheduling, tasks and waitlists in sync" },
  { value: "RCM", label: "Eligibility, claims and AR in one flow" },
  { value: "HRMS", label: "Teams, roles and operations connected" },
];

export const Stats = () => {
  return (
    <section id="metrics" data-testid="stats-band" className="relative z-10 bg-[#0C2A40]">
      <div className="max-w-[1600px] mx-auto px-6 md:px-10 py-7 flex flex-col md:flex-row md:items-center md:justify-between gap-6">
        <p className="font-mono text-[11px] tracking-[0.2em] uppercase text-[#9FD0EC] shrink-0">
          / Built for EHR, PMS and revenue command
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-5 md:gap-10 flex-1 md:justify-items-end">
          {stats.map((s, i) => (
            <motion.div
              key={s.label}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.08, duration: 0.6 }}
              className="text-left md:text-right"
            >
              <div className="font-mono text-2xl md:text-3xl font-bold text-white tracking-tight">{s.value}</div>
              <div className="mt-1 max-w-[220px] font-mono text-[10px] tracking-[0.12em] uppercase text-[#A9C4DD]">{s.label}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
